import { dataFileStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileStarSolid = /*#__PURE__*/createIcon(dataFileStarSolid)
export default IconFileStarSolid
